import React from 'react';
import axios from 'axios';
import { Grid } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { PropTypes } from 'prop-types';
import { validationSchemaForServiceToMyAccount } from '../balance-cancellation/FormModel/validationSchema';
import { formInitialValuesForServiceToMyAccount } from '../balance-cancellation/FormModel/formInitialValues';
import { CommonStyles } from '../balance-cancellation/CommonStyles';
import { base64Authorization } from '../utils/CommonFunctions';
import NewConciergeCustomerForm from './NewConciergeCustomerForm';
import { generateuuid } from '../../../app/CommonFunction';
import { API_CONFIG } from '../../../config/apiconfig';

const useCommonStyles = CommonStyles();

const NewConciergeCustomerContainer = (props) => {
  const CommonCssStyles = useCommonStyles();
  const {
    englishBot,
    sessionID,
    setNewConciergeCustomer,
    formInProcessTrigger,
    handeButtonLinkMessage,
    setCustomerDetails,
    spinnerHandler,
    setShowRegisterCustomerButton,
    liveAgentJoined,
    sendToConnect,
    token,
    getAccessToken,
  } = props;

  const handleFormSubmit = (values, actions) => {
    setNewConciergeCustomer(false);
    formInProcessTrigger(false);
    setShowRegisterCustomerButton(false);
    if (liveAgentJoined) {
      let cusDetails = `customerName: ${values.firstName} ${values.lastName}\n customerEmail: ${values.personEmail}\n customerMobile: ${values.mobileNumber}\n customerDob: ${values.dob_date}\n customerSSN: ${values.socialSecurityNumber}`;
      cusDetails += values.accountNumber ? `\n customerAccountNumber: ${values.accountNumber}` : '';
      sendToConnect(cusDetails);
    } else {
      const params = {
        sessionId: sessionID,
        customerEmail: values.personEmail,
        mobileNumber: `${values.mobileNumber}`,
        customerName: `${values.firstName} ${values.lastName}`,
        accountNumber: values.accountNumber,
        dob: values.dob_date,
        ssn: values.socialSecurityNumber,
        lineOfBusiness: values.accountType,
        conciergeCustomer: 'N',
      };
      // axios
      //   .post(
      //     process.env.REACT_APP_TOKEN_SERVICE_URL,
      //     {},
      //     {
      //       headers: {
      //         Authorization: `Basic ${base64Authorization}`,
      //         'Content-Type': 'application/x-www-form-urlencoded',
      //       },
      //     }
      //   )
      //   .then((response) => {
      const uuid = generateuuid();
      axios
        .post(`${API_CONFIG.USER_FORM_URL}`, params, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_X_API_KEY,
            appid: 'comms',
            sessionId: sessionID,
            source: 'Chatbot',
            lang: englishBot ? 'ENG' : 'ESP',
            uuid,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.messages && data.messages[0].content.includes('templateType')) {
            const listPickerData = JSON.parse(data.messages[0].content);
            setCustomerDetails(listPickerData.data.content.sessionAttributes);
            setTimeout(() => {
              spinnerHandler(false);
              handeButtonLinkMessage(
                { text: listPickerData.data.content.title, value: '', isButtonMessage: false },
                false
              );
            }, 1000);
          }
        })
        .catch((err) => {
          spinnerHandler(false);
          if (
            err.message === 'Request failed with status code 403' ||
            err.message === 'Request failed with status code 401'
          ) {
            getAccessToken(true, 'liveAgent', params);
          }
        });
      // })
      // .catch();
    }
  };
  return (
    <Formik
      initialValues={formInitialValuesForServiceToMyAccount}
      validationSchema={validationSchemaForServiceToMyAccount}
      onSubmit={handleFormSubmit}
      data-testid="submit_testid"
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Grid item xs={12} className={CommonCssStyles.steps_grid} style={{ margin: '10px' }}>
            <NewConciergeCustomerForm
              englishBot={englishBot}
              setNewConciergeCustomer={setNewConciergeCustomer}
              spinnerHandler={spinnerHandler}
              liveAgentJoined={liveAgentJoined}
            />
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
NewConciergeCustomerContainer.propTypes = {
  englishBot: PropTypes.bool,
  sessionID: PropTypes.string,
  setNewConciergeCustomer: PropTypes.func,
  formInProcessTrigger: PropTypes.func,
  handeButtonLinkMessage: PropTypes.func,
  setCustomerDetails: PropTypes.object,
  spinnerHandler: PropTypes.func,
  setShowRegisterCustomerButton: PropTypes.func,
  liveAgentJoined: PropTypes.bool,
  sendToConnect: PropTypes.func,
};
export default NewConciergeCustomerContainer;
